import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";


import { AuthRouteConnected, ProtectedRouteConnected } from "../util/route_util";
import TokenExpiryWatcher from "./TokenExpiryWatcher";
import PostCourseContainer from "./courses/PostCourseContainer";
// Lazy-loaded routes
const Dashboard = lazy(() => import("./dashboard/dashboard_container"));
const AdminDashboardContainer = lazy(() => import("./admin/admin_dashboard_container"));
const StudentMessengerContainer = lazy(() => import("./messages/student_messenger_container"));
const MasterMessagesDashboardContainer = lazy(() => import("./messages/master_messages_dashboard_container"));
const OmbrePrepContainer = lazy(() => import("./courses/OmbrePrepContainer"));
const SessionExpiredModal = lazy(() => import("./session/SessionExpiredModal"));
const SignupContainer = lazy(() => import("./session/signup_form_container"));
const LoginFormContainer = lazy(() => import("./session/login_form_container"));

const RouteFallback = () => (
  <div className="boot-splash">
    <div className="boot-orb" />
    <div className="boot-text">COSMETINK ACADEMY</div>
  </div>
);

const App = () => (
  <Suspense fallback={<RouteFallback />}>
    <div className="main">
      <TokenExpiryWatcher />
      <SessionExpiredModal />

      <Routes>
        <Route
          path="/"
          element={
            <AuthRouteConnected>
              <Navigate to="/login" replace />
            </AuthRouteConnected>
          }
        />

        <Route
          path="/signup"
          element={
            <AuthRouteConnected>
              <SignupContainer />
            </AuthRouteConnected>
          }
        />

        <Route
          path="/login"
          element={
            <AuthRouteConnected>
              <LoginFormContainer />
            </AuthRouteConnected>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRouteConnected>
              <Dashboard />
            </ProtectedRouteConnected>
          }
        />

        <Route
          path="/admin"
          element={
            <ProtectedRouteConnected>
              <AdminDashboardContainer />
            </ProtectedRouteConnected>
          }
        />
        
        <Route path="/courses/post/:courseKey" element={
               <ProtectedRouteConnected>
                <PostCourseContainer />
                </ProtectedRouteConnected>} />     
        
        
        <Route
          path="/messages"
          element={
            <ProtectedRouteConnected>
              <StudentMessengerContainer />
            </ProtectedRouteConnected>
          }
        />

        <Route
          path="/admin/messages"
          element={
            <ProtectedRouteConnected>
              <MasterMessagesDashboardContainer />
            </ProtectedRouteConnected>
          }
        />

        <Route
          path="/courses/prep/:courseKey"
          element={
            <ProtectedRouteConnected>
              <OmbrePrepContainer />
            </ProtectedRouteConnected>
          }
        />
      </Routes>
    </div>
  </Suspense>
);

export default App;
